import { eventLoader } from "../../../exports/event-loader";
import { storage } from "../../../exports/storage";
/*                                            */
import { deviceEvents, EVENTS, type HybridDetectedEventData } from "./events.js";
/*                                                                               */
import type { DeviceEvents } from "./events.js";
import { executeCallbackAsync } from "./callback";
import { isTouchable } from "./touch.js";

const eventName = "mousemove";

const storageKey = "isHybrid";
/*                                                                                                   */
const minMovesForSuccess = 3;
/*                                                                                 */
const maxTimeForSuccess = 300;
/*                                                                          */
const mayAttemptsForSuccess = 8;

function markHybrid<T extends Hybrid>(instance: T, data: HybridDetectedEventData): T {
  instance.isHybrid = true;
  deviceEvents.emitRetain(EVENTS[0], data);
  otto.device.pointerType.set({ isTouchable: true, isHybrid: true });
  instance.document.classList.add("touchable-hybrid");
  return instance;
}

/**
 *
 */
export class Hybrid {
  private storage = storage(() => window.sessionStorage);

  /*                                                                                     */
  private mouseMoveCounter = 0;

  /*                                                                      */
  private checkCounter = 0;

  /*                                                                                        */
  private timeoutIdArr: number[] = [];

  /*                                */
  isHybrid = false;

  /*                                */
  get isDetected(): boolean {
    return this.isHybrid;
  }

  /*                       */
  private callbacks: (() => void)[] = [];

  /*                               */
  document = document.documentElement;

  /**
 *
 *
 */
  detect(): this {
    if (!isTouchable()) {
      /*                                              */
      return this;
    }

    if (this.storage.getItem(storageKey) === "true") {
      /*                                              */
      return markHybrid(this, { fromStorage: true });
    }

    if (!this.storage.getItem(storageKey)) {
      /*                                                                          */
      eventLoader.onAllJavascriptLoaded(200, () =>
        executeCallbackAsync(() => this.document.addEventListener(eventName, this.checkMouseMoves)),
      );
    }

    return this;
  }

  /**
 *
 *
 *
 *
 *
 *
 */
  onHybridDetected(callback: () => void): void {
    if (this.isHybrid) {
      executeCallbackAsync(callback);
      return;
    }

    this.callbacks.push(callback);
  }

  /*                                                   */
  executeOrRegisterCallback = this.onHybridDetected;

  /*                                     */
  private checkMouseMoves = (): void => {
    this.mouseMoveCounter += 1;

    if (this.mouseMoveCounter > minMovesForSuccess) {
      this.cleanup();
      /*                     */
      markHybrid(this, { fromDetector: true });
      /*                                   */
      this.storage.setItem(storageKey, "true");
      /*                        */
      this.callbacks.forEach(executeCallbackAsync);
    }

    /*                                             */
    if (this.isHybrid) {
      /*                                */
      return;
    }

    /*                       */
    /*                                      */
    /*                                       */
    const timeoutId = window.setTimeout(
      () => {
        /*                                                                 */
        this.mouseMoveCounter -= 1;
        this.checkCounter += 1;

        if (this.checkCounter > mayAttemptsForSuccess) {
          this.cleanup();
          this.storage.setItem(storageKey, "false");
        }
      },
      /*                                              */
      maxTimeForSuccess,
    );

    this.timeoutIdArr.push(timeoutId);
  };

  private cleanup(): void {
    this.timeoutIdArr.filter(Boolean).forEach(clearTimeout);
    this.document.removeEventListener(eventName, this.checkMouseMoves);
  }
}

/**
 *
 *
 *
 */
export function hybrid(): Hybrid {
  return new Hybrid().detect();
}
